document.addEventListener(
  "DOMContentLoaded",
  () => {

    const cards =
      document.querySelectorAll(
        "#thread-finish-grid .option-card"
      );

    const hidden =
      document.getElementById(
        "threadFinish"
      );

    if (!cards.length || !hidden) {
      console.log(
        "THREAD FINISH NOT FOUND"
      );
      return;
    }

    cards.forEach(card => {

      card.addEventListener(
        "click",
        () => {

          cards.forEach(c =>
            c.classList.remove("active")
          );

          card.classList.add(
            "active"
          );

          hidden.value =
            card.dataset.finish;

          console.log(
            "THREAD FINISH:",
            hidden.value
          );

          document.dispatchEvent(
            new CustomEvent(
              "embroideryUpdated"
            )
          );

        }
      );

    });

  }
);